// Enlaces de navegacion publica (tienda)
const navConfig = [
  { title: 'Catálogo', path: '/catalogo' },
  { title: 'Ofertas', path: '/ofertas' },
  { title: 'Cotizador de PC', path: '/cotizador' },
  { title: 'Servicio técnico', path: '/servicio-tecnico' },
  { title: 'Acerca de nosotros', path: '/acerca-de-nosotros' },
];

export default navConfig;
